export const getWeekTableRange = (time: number) => {
  const min = Math.floor(time / 60)
  const second = time % 60
  return min * 74 + second * 1.23 + 1
}